import { Channel } from '@models/channel';
import { CmRegion } from '@models/channel-maps/cm-region';
import { CmSubRegion } from '@models/channel-maps/cm-sub-region';
import { Annex } from '@models/enums';
import { MapEntry } from '@models/map-entry';
import { ObjectHelper } from '@utilities/object-helper';


/**
 * ChannelMap is a representation of the configuration of all upstream and downstream configured on plant.  It provides all the information the meter
 * needs in order to lock onto specific channels, and it also provides the type and content for each channel.
 */
export class ChannelMap {
  id: number;
  name: string;
  description: string;
  region: CmRegion;
  subRegion: CmSubRegion;
  annex: Annex;
  createdOn: number;
  updatedOn: number;
  createdBy: string;
  updatedBy: string;
  active = true;
  channelMapEntries: MapEntry;
  planType: string;
  owner: string;
  channelIn: string;
  /**
   * We do use the empty constructor.  Adding it here to indicate it's usage, event though there is no custom logic in here
   */
  constructor() { }

  /**
   * This static function is intended to operate like an overloaded constructor where we return an instance of the object based on input parameters.
   * The purpose of this function is to map values from the api response into our standardized ChannelMap object
   * @param httpResponse
   */
  static getChannelMapFromHttpResponse(httpResponse: any): ChannelMap {
    const channelMap = ObjectHelper.copyObject(httpResponse, ChannelMap);
    channelMap.channelMapEntries = new MapEntry();
    for (const [frequency, channelIn] of Object.entries(httpResponse['channelMapEntries'])) {
      const channel = ObjectHelper.copyObject(channelIn as Channel, Channel);
      channel.frequency = channel.frequency ? channel.frequency : channel.freq;
      channelMap.channelMapEntries.set(frequency, channel);
    }
    return channelMap;
  }

  toJsn(): string {
    return JSON.stringify(this);
  }
}
